export const LOADING_START = 'loading.start';

export const LOADING_END = 'loading.end';

export const LOADING_END_NETWORK_FAILURE = 'loading.end_network_failure';
